/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform;
(function (FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform) {
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["Unspecified"] = "Unspecified";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["Custom"] = "Custom";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["Android"] = "Android";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["AndroidX86"] = "AndroidX86";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["Amazon"] = "Amazon";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["DigiCaviar"] = "DigiCaviar";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["Ios"] = "Ios";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["WindowsX64"] = "WindowsX64";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["SteamX64"] = "SteamX64";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["RuStore"] = "RuStore";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["AppBazar"] = "AppBazar";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["MailRuX64"] = "MailRuX64";
    FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform["UnknownDefaultOpenApi"] = "11184809";
})(FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform || (FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform = {}));
export function instanceOfFtlSharedGeneratedApiFtlDomainEnumsReleasePlatform(value) {
    for (const key in FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform) {
        if (Object.prototype.hasOwnProperty.call(FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform, key)) {
            if (FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformFromJSON(json) {
    return FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformFromJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformToJSON(value) {
    return value;
}
export function FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform.js.map